
<template>
    <b-modal
        v-model="mostrarModalEvento"
        @show="preencher()"
        @hide="fecharModal()"
        @close="fecharModal()"
    >
        <div slot="modal-title">
            Meta -
            <b-badge variant="warning">{{ operacaoProp }}</b-badge>
        </div>
        <b-row class="d-flex justify-content-center align-items-center">
            <b-col sm="6" md="6">
                <b-form-group>
                    <label for="codGestor">Tipo de Meta: </label>
                    <b-input-group>
                        <b-form-select
                            v-model="tipoDaMeta"
                            type="text"
                            :options="tipoMeta"
                            value-field="value"
                            text-field="text"
                            @change="selecionaTipoDeMeta()"
                        >
                        </b-form-select>
                        <b-form-invalid-feedback
                            >Tipo é obrigatório</b-form-invalid-feedback
                        >
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div v-if="tipoDaMeta == 1">
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Nome do Evento</label>
                        <b-input-group>
                            <b-form-input
                                type="text"
                                v-model="nomeEvento"
                                @input="$v.nomeEvento.$touch()"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                                O nome é Obrigatório
                            </b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Código do Evento</label>
                        <b-input-group>
                            <b-form-input
                                type="number"
                                v-model="codEvento"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div v-if="tipoDaMeta == 0">
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Nome da Consultoria</label>
                        <b-input-group>
                            <b-form-input type="text" v-model="nomeConsultoria"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label >Total Previsto(Horas)</label>
                        <b-input-group>
                            <b-form-input type="number" v-model="totalPrevisto"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Total Realizado(Horas)</label>
                        <b-input-group>
                            <b-form-input type="number" v-model="totalRealizado" disabled></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

        </div>
        <div v-if="tipoDaMeta == 2">
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Nome da Entrega</label>
                        <b-input-group>
                            <b-form-input type="text" v-model="nomeEntrega"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label >Total Previsto</label>
                        <b-input-group>
                            <b-form-input type="number" v-model="totalPrevisto"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

        </div>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button variant="primary" :disabled="$v.$invalid" @click.stop="salvar()" class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        operacao: {
            type: String,
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },

        evento: {
            type: Object,
            default: () => { }
        },

        acao: {
            type: Object,
            default: () => { }
        },

        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        nomeEvento: {
            nomeEventoOk() {
                if (this.nomeEvento == null && this.nomeConsultoria == null && this.nomeEntrega?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeConsultoria == null && this.nomeEntrega == null&& this.nomeEvento?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeEntrega == null && this.nomeEvento == null&& this.nomeConsultoria?.length > 0 ) {
                        return true ;
                    }
                    return false;
            }
        },
        
        nomeConsultoria: {
            nomeConsultoriaOk() {
                    if (this.nomeEvento == null && this.nomeConsultoria == null && this.nomeEntrega?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeConsultoria == null && this.nomeEntrega == null&& this.nomeEvento?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeEntrega == null && this.nomeEvento == null&& this.nomeConsultoria?.length > 0 ) {
                        return true ;
                    }
                    return false;
                }
            },
        nomeEntrega: {
            nomeEntregaOk() {
                    if (this.nomeEvento == null && this.nomeConsultoria == null && this.nomeEntrega?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeConsultoria == null && this.nomeEntrega == null&& this.nomeEvento?.length > 0 ) {
                        return true ;
                    }
                    if (this.nomeEntrega == null && this.nomeEvento == null&& this.nomeConsultoria?.length > 0 ) {
                        return true ;
                    }
                    return false;
                }
            }
    },

    data() {
        return {
            mostrarModalEvento: false,
            codEvento: null,
            nomeEvento: null,
            idEvento: null,
            idConvenio: null,
            idConsultoria: null,
            totalPrevisto: 0,
            nomeConsultoria: null,
            nomeEntrega:null,
            totalRealizado: 0,
            tipoDaMeta: null,
            operacaoProp: 'INSERÇÃO',
            tipoMeta:
                [
                    { value: 0, text: 'Consultoria' },
                    { value: 2, text: 'Entrega' },
                    { value: 1, text: 'Evento' }

                ]
            ,
        }

    },

    methods: {
        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        resetar() {
            this.mostrarModalEvento = false
            this.nomeEvento = null
            this.nomeEntrega = null
            this.idEntrega = null
            this.codEvento = null
            this.idEvento = null
            this.idConsultoria = null
            this.totalPrevisto = 0
            this.totalRealizado = 0
            this.nomeConsultoria = null
            this.idConvenio = null
        },

        preencher() {
            
            this.nomeEvento = null
            this.nomeConsultoria = null
            this.nomeEntrega = null
            this.tipoDaMeta = null
            this.totalPrevisto = 0
            this.totalRealizado = 0
            

        },

        selecionaTipoDeMeta() {
            if(this.tipoDaMeta == 0){
                this.nomeEvento = null
                this.nomeEntrega = null
                this.codEvento = 0
                this.totalPrevisto = 0

            }
            if(this.tipoDaMeta == 1){
                this.nomeConsultoria = null
                this.nomeEntrega = null
                this.totalPrevisto = 0
                this.totalRealizado = 0
            }
            if(this.tipoDaMeta == 2){
                this.nomeConsultoria = null
                this.nomeEvento = null
                this.codEvento = 0
                this.totalPrevisto = 0
                this.totalRealizado = 0
            }
        },
        salvar() {
            if (this.tipoDaMeta == 1) {
                let eventoDto = {
                    nomeEvento: this.nomeEvento,
                    codEvento: this.codEvento,
                    tipoDaMeta: this.tipoDaMeta,
                    idEvento: this.idEvento,
                    idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho
                }
                this.$emit('salvar', eventoDto)
                this.resetar()
            }
            if (this.tipoDaMeta == 0) {
                let consultoriaDto = {
                    idConvenio: this.acao.idConvenio,
                    nomeConsultoria: this.nomeConsultoria,
                    totalPrevisto: this.totalPrevisto,
                    totalRealizado: this.totalRealizado,
                    tipoDaMeta: this.tipoDaMeta,
                    idConsultoria: this.IdConsultoria,
                    idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho
                }
                this.$emit('salvar', consultoriaDto)
                this.resetar()
            }
            if (this.tipoDaMeta == 2) {
                let entregaDto = {
                    idConvenio: this.acao.idConvenio,
                    nomeEntrega: this.nomeEntrega,
                    totalPrevisto: this.totalPrevisto,
                    tipoDaMeta: this.tipoDaMeta,
                    idEntrega: this.IdEntrega,
                    idAcaoPlanoTrabalho: this.acao.idAcaoPlanoTrabalho
                }
                this.$emit('salvar', entregaDto)
                this.resetar()
            }
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalEvento = this.mostrarModal
            if (this.operacao == 'A') {
                this.operacaoProp = 'ATUALIZAÇÃO'
            }
        }
    }
}
</script>
